// extracted by mini-css-extract-plugin
module.exports = {"reviewCardContainer":"ReviewSummaryCard_reviewCardContainer__in_Iq","numericalRating":"ReviewSummaryCard_numericalRating__BB8wL"};